import { Pipe, PipeTransform } from '@angular/core';

/**
 * Safely formats simple markdown-like text for chat display:
 * - Escapes HTML
 * - Converts newlines to <br>
 * - Supports *bold* and **bold** to <strong>
 * This is intentionally minimal and not a full Markdown parser.
 */
@Pipe({
  name: 'formatMessage',
  standalone: true
})
export class FormatMessagePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    const raw = (value ?? '').toString();
    if (!raw) return '';

    // 1) Escape HTML to prevent XSS
    const escaped = raw
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // 2) Bold: handle **bold** first, then *bold*
    const withBold = escaped
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/(^|\s)\*(.+?)\*(?=\s|$)/g, (_m, p1, p2) => `${p1}<strong>${p2}</strong>`);

    // 3) Headings: convert lines starting with "## " to <h2>...</h2>
    const withHeadings = withBold.replace(/(^|\n)##\s+(.+?)(?=\n|$)/g, (_m, p1, p2) => `${p1}<h2>${p2}</h2>`);

    // 4) Dashes at line start for bullets: convert "- " at start to &ndash; with spacing (optional nicety)
    const withBullets = withHeadings.replace(/(^|\n)-\s/g, '$1&ndash; ');

    // 5) Newlines to <br>
    const withBreaks = withBullets.replace(/\n/g, '<br>');

    return withBreaks;
  }
}